import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import { KlinePeriodTime, tabConfig } from '../config';
import { memo } from 'react';

interface PeriodSelectorProps {
  period: KlinePeriodTime;
  onPeriodChange: (period: KlinePeriodTime) => void;
}

export default memo(({ period, onPeriodChange }: PeriodSelectorProps) => (
  <Tabs value={period} className="w-full" onValueChange={(e) => onPeriodChange(e as KlinePeriodTime)}>
    <TabsList className="rounded-[8px] h-[36px] p-[4px] w-full">
      {tabConfig.map((item) => (
        <TabsTrigger
          key={item.value}
          value={item.value}
          className={cn('w-full h-[28px] font-[400] rounded-[6px]', period == item.value ? 'shadow-[0px_2px_4px_-2px_rgba(196,196,196,0.2)]' : '')}
        >
          {item.label}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
));
